<template>
    <div class="add-role-form container my-4 p-4 border rounded shadow-sm bg-white">
      <h3 class="mb-4 text-center">{{ isEditMode ? 'Edit Role' : 'Add New Role' }}</h3>
      <form @submit.prevent="submitRole" novalidate>
        <div class="mb-3">
          <label for="role_name" class="form-label">Role Name <span class="text-danger">*</span></label>
          <input
            type="text"
            id="role_name"
            class="form-control"
            placeholder="Enter role name"
            v-model="form.role_name"
            required
          />
        </div>
        <div class="mb-3">
          <label for="description" class="form-label">Description</label>
          <textarea
            id="description"
            class="form-control"
            rows="3"
            placeholder="Enter description (optional)"
            v-model="form.description"
          ></textarea>
        </div>
        <div class="d-flex justify-content-between">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-plus-circle me-2"></i> {{ isEditMode ? 'Update Role' : 'Create Role' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </template>

<script>
import Vue from 'vue'
import axios from 'axios'

import { bus } from './../../../main.js'

export default {
  name: 'AddEditRole',
  props: {
    role: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        role_name: '',
        description: ''
      }
    }
  },
  computed: {
    isEditMode() {
      return this.role !== null
    }
  },
  watch: {
    role: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            role_name: newVal.role_name || '',
            description: newVal.description || ''
          }
        } else {
          this.form = {
            role_name: '',
            description: ''
          }
        }
      }
    }
  },
  methods: {
    submitRole() {
      if (!this.form.role_name.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Role name is required.'
        })
        return
      }
      if (this.isEditMode) {
        if (!this.role || !this.role.role_id) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Role ID is missing. Cannot update role.'
          })
          return
        }
        // Update existing role
        axios.put(`/user/roles/${this.role.role_id}`, {
          role_name: this.form.role_name,
          description: this.form.description
        })
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Role updated successfully!'
          })
          this.$emit('role-updated')
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update role.'
          })
        })
      } else {
        // Create new role
        axios.post('/user/roles/create', {
          role_name: this.form.role_name,
          description: this.form.description
        })
        .then(() => {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Role added successfully!'
          })
          this.form.role_name = ''
          this.form.description = ''
          this.$emit('role-added')
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to add role.'
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/users/AddEditRole.vue